import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'benefits-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class ButtonGroupComponent {}
